import { render, staticRenderFns } from "./WindowPortal.vue?vue&type=template&id=bc1bb26a&scoped=true"
import script from "./WindowPortal.vue?vue&type=script&lang=js"
export * from "./WindowPortal.vue?vue&type=script&lang=js"
import style0 from "./WindowPortal.vue?vue&type=style&index=0&id=bc1bb26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1bb26a",
  null
  
)

export default component.exports